import classes from "./transaction-history-container.module.css";
import cx from "classnames";
import {
  PENDING,
  transactionKeyLabelMap,
  transactionLabelMap
} from "../../services/constants";
import TransactionTableStatus from "./TransactionTableStatus";
import EmptyState from "./EmptyState";
import useModalStore from "zustandStores/useModalStore";
import { JhUseToast } from "designPackages/toastPackage";
import { useState } from "react";
import { JhText } from "designPackages/textPackage";
import { getInvoiceEmail } from "utils/invoiceUtils";

const Card = props => {
  const { transactionData = [], onInvoiceClick, loadingInvoiceId } = props;

  return transactionData.map((row, index) => {
    const {
      transactionLabel = "",
      lastUpdated = "",
      status = "",
      credits = "",
      expirationDate = "",
      transactionDate = "",
      transactionTime = "",
      closingBalance = "",
      orderId = "",
      isInvoiceAvailable = false,
      invoiceEmail = ""
    } = row;

    const labelValues = transactionLabelMap[transactionLabel] || [];

    const transactionSubLabel = Object.fromEntries(
      Object.entries(row).filter(([key]) => labelValues.includes(key))
    );

    return (
      <div key={index} className={classes.cardRoot}>
        <div className={classes.transactionHeader}>
          <div className={classes.transactionLabel}>
            {transactionLabel}
            <div className={classes.updatedAt}>{lastUpdated}</div>
          </div>
          <TransactionTableStatus status={status} />
        </div>

        {Object.entries(transactionSubLabel).map(([key, value]) => (
          <div className={classes.tableData} key={key}>
            <div className={classes.cellHeader}>
              {transactionKeyLabelMap[key]}
            </div>
            <div className={classes.cellData}>{value}</div>
          </div>
        ))}

        <div className={classes.tableData}>
          <div className={classes.cellHeader}>Credits</div>
          <div className={classes.cellData}>
            <div className={cx(classes.cellHeading, classes.credits)}>
              {credits}
            </div>
            <div className={classes.cellSubHeading}>{expirationDate}</div>
          </div>
        </div>
        <div className={classes.tableData}>
          <div className={classes.cellHeader}>Date & Time</div>
          <div className={classes.cellData}>
            <span className={classes.expiryDate}>{transactionDate}</span>
            <span className={classes.cellSubHeading}>{transactionTime}</span>
          </div>
        </div>
        <div className={cx(classes.tableData, classes.balanceContainer)}>
          <div className={classes.cellHeader}>Closing Balance</div>
          <div className={classes.cellData}>
            {status === PENDING ? "--" : closingBalance}
          </div>
        </div>
        <div className={classes.tableData}>
          <div className={classes.cellHeader}>Invoice</div>
          <div className={classes.cellData}>
            <div className={cx(classes.cellHeading, classes.credits)}>
              {isInvoiceAvailable && orderId ? (
                <JhText
                  variant="caption1"
                  color="primary"
                  className="cursor-pointer"
                  onClick={() => onInvoiceClick({ orderId, invoiceEmail })}
                  disabled={loadingInvoiceId === orderId}
                >
                  Get Invoice
                </JhText>
              ) : (
                <div className={classes.cellHeading}>--</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  });
};

const ReservedCard = props => {
  const { transactionData = [] } = props;
  return transactionData.map((row, index) => {
    const {
      jobTitle = "",
      cityLocalityData = "",
      salary = "",
      openings = "",
      jobId = "",
      credits = "",
      status = "",
      jobPostingDate = "",
      jobPostingTime = "",
      companyName = ""
    } = row;

    return (
      <div key={index} className={classes.cardRoot}>
        <div className={classes.transactionHeader}>
          <div className={classes.transactionLabel}>
            {jobTitle}
            <div className={classes.reservedJobInfo}>
              {companyName ? (
                <div className={classes.companyName}>
                  Posted for {companyName}
                </div>
              ) : null}
              <div>{cityLocalityData}</div>
              <div>
                {salary ? <>{salary} | </> : null}
                {openings}
              </div>
              <div>Job Id - {jobId}</div>
            </div>
          </div>
          <TransactionTableStatus status={status} />
        </div>

        <div className={classes.tableData}>
          <div className={classes.cellHeader}>Credits Reserved</div>
          <div className={classes.cellData}>
            <div className={cx(classes.cellHeading, classes.credits)}>
              {credits}
            </div>
          </div>
        </div>
        <div className={classes.tableData}>
          <div className={classes.cellHeader}>Date & Time</div>
          <div className={classes.cellData}>
            <span className={classes.expiryDate}>{jobPostingDate}</span>
            <span className={classes.cellSubHeading}>{jobPostingTime}</span>
          </div>
        </div>
      </div>
    );
  });
};

function TransactionMobileCards(props) {
  const { transactionData = [], isReservedTab } = props;

  const { setModalData } = useModalStore(state => ({
    setModalData: state.setModalData
  }));

  const { toast } = JhUseToast();

  const [loadingInvoiceId, setLoadingInvoiceId] = useState(null);

  const handleInvoiceClick = async ({ orderId, invoiceEmail }) => {
    await getInvoiceEmail({
      orderId,
      invoiceEmail,
      toast,
      setLoadingInvoiceId,
      setModalData
    });
  };

  return (
    <div className={classes.cardContainer}>
      {!transactionData.length ? (
        <EmptyState />
      ) : (
        <>
          {isReservedTab ? (
            <ReservedCard transactionData={transactionData} />
          ) : (
            <Card
              transactionData={transactionData}
              onInvoiceClick={({ orderId, invoiceEmail }) =>
                handleInvoiceClick({ orderId, invoiceEmail })
              }
              loadingInvoiceId={loadingInvoiceId}
            />
          )}
        </>
      )}
    </div>
  );
}

export default TransactionMobileCards;
